import { useState, useEffect, useRef } from "react";
import nexuslogo from  "../assets/Gallery_Nexus/nexus_logo.png";

const LINKS = [
 {
    href: "/experts",
    label: "Experts",
    children: [
        { href: "/experts#nlp", label: "NLP Psychotherapies" },
        { href: "/experts#hypnotherapy", label: "Hypnotherapy" },
        { href: "/experts#occupational-speech", label: "Occupational & Speech Therapies" },
        { href: "/experts#psychiatrists", label: "Expert Psychiatrists" },
        { href: "/experts#couples", label: "Couple Therapist" },
        { href: "/experts#psychotherapists", label: "Psychotherapists" },
        { href: "/experts#child-therapists", label: "Child Therapists" },
    ],
  },
  {
    href: "/clinics",
    label: "Clinics",
    children: [
      { href: "/clinics/mumbai", label: "Mumbai" },
      { href: "/clinics/centralmumbai", label: "Thane/Kalyan/Vashi" },
      { href: "/clinics/newdelhi", label: "New Delhi" },
      { href: "/clinics/pune", label: "Pune" },
      { href: "/clinics/uttarpradesh", label: "Uttarpradesh" },
      { href: "/clinics/gujrat", label: "Gujrat" },
    ],
  },
    {
        href: "/services",
        label: "Services",
        children: [
            {
                href: "/wellnessprograms#development", label: "Development Facilities",
            },
            {
                href: "/wellnessprograms#children", label: "Children Therapists",
            },
            {
                href: "/wellnessprograms#hospitals",label: "Mental Health Hospitals",
            },
          
           
            {
                href: "/wellnessprograms#adulttherapy",label: "Adult Therapy",
            },
            {
                href: "/wellnessprograms#adultpsychiatrists",label: "Adult Psychiatrists",
            },
            {
                href: "/wellnessprograms#psychometric",label: "Psychological Testing",
            },
            {
                href: "/wellnessprograms#deeptms",label: "Advanced Treatments",
            },
        ],
    },

  {
    href: "/mentalconditions",
    label: "Mental Conditions",
    children: [
      { href: "/mentalconditions#ocd", label: "Obsessive Compulsive Disorder (OCD)" },
        { href: "/mentalconditions#addiction", label: "Addiction" },
        { href: "/mentalconditions#childrenadhd", label: "Children ADHD" },
        { href: "/mentalconditions#adultadhd", label: "Adult ADHD" },

      { href: "/mentalconditions#depression", label: "Depression" },
      { href: "/mentalconditions#anxiety", label: "Anxiety" },
      { href: "/mentalconditions#womenshealth", label: "Women’s Health" },
        { href: "/mentalconditions#bipolar", label: "Bipolar Disorder" },
        { href: "/mentalconditions#schizophrenia", label: "Schizophrenia" },
        { href: "/mentalconditions#ptsd", label: "PTSD" },
        { href: "/mentalconditions#hallucinations", label: "Hallucinations" }, 
        { href: "/mentalconditions#autism", label: "Autism Spectrum Disorder (ASD)" }, 
        { href: "/mentalconditions#drugdeaddiction", label: "Drug De-Addiction" }, 
      { href: "/mentalconditions#trichotillomania", label: "Trichotillomania" },
      { href: "/mentalconditions#catatonia", label: "Catatonia" },
      { href: "/mentalconditions#neurotic", label: "Neurotic Disorders" },
      { href: "/mentalconditions#eatingdisorder", label: "Eating Disorder" },
    ],
  },
  
  { href: "/about", label: "About Us" },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // desktop hover/focus
  const [mobileOpenSubmenus, setMobileOpenSubmenus] = useState({});
  const closeTimeoutRef = useRef(null);

  useEffect(() => {
    function onResize() {
      if (window.innerWidth >= 768) setOpen(false);
    }
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }
    };
  }, []);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 glass-nav">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
              <div className="flex items-center gap-3 sm:gap-4">

                  {/* Logo */}
                  <a
                      href="/"
                      aria-label="Nexus Mental Health Foundation"
                      className="group shrink-0"
                  >
                      <div
                          className="
                h-12 w-12
                sm:h-14 sm:w-14
                md:h-16 md:w-16
                lg:h-20 lg:w-20
                rounded-xl
                bg-white
                p-[2px]
                shadow-md
                ring-1 ring-white/30
                transition-all duration-300
                group-hover:scale-105
            "
                      >
                          <img
                              src={nexuslogo}
                              alt="Nexus Mental Health Foundation"
                              className="
                    h-full
                    w-full
                    rounded-[10px]
                    object-cover
                "
                          />
                      </div>
                  </a>

                  {/* Tagline */}
                  <div className="hidden sm:block leading-tight">
                      <h1 className="
            text-base
            md:text-lg
            lg:text-xl
            font-bold
            tracking-wide
            text-white
        ">
                          Mental Health Care
                      </h1>

                      <p className="
            mt-1
            text-xs
            md:text-sm
            font-medium
            tracking-wide
            text-cyan-300
        ">
                          That Meets You Where You Are - Nexus
                      </p>
                  </div>

              </div>

        <button
          className="md:hidden p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-200 glossy-btn relative"
          aria-controls="primary-navigation"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className="sr-only">Toggle menu</span>
          {open ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        <ul
          id="primary-navigation"
          className={`hidden md:flex md:items-center md:gap-3 text-sm font-medium ${open ? "block" : ""}`}
        >
          {LINKS.map((link) => {
            const hasChildren = Array.isArray(link.children) && link.children.length > 0;
            return (
              <li
                key={link.href}
                className="relative"
                onMouseEnter={() => {
                  if (!hasChildren) return;
                  if (closeTimeoutRef.current) {
                    clearTimeout(closeTimeoutRef.current);
                    closeTimeoutRef.current = null;
                  }
                  setActiveDropdown(link.href);
                }}
                onMouseLeave={() => {
                  if (!hasChildren) return;
                  closeTimeoutRef.current = setTimeout(() => {
                    setActiveDropdown(null);
                    closeTimeoutRef.current = null;
                  }, 200);
                }}
                onFocus={() => {
                  if (!hasChildren) return;
                  if (closeTimeoutRef.current) {
                    clearTimeout(closeTimeoutRef.current);
                    closeTimeoutRef.current = null;
                  }
                  setActiveDropdown(link.href);
                }}
                onBlur={() => {
                  if (!hasChildren) return;
                  closeTimeoutRef.current = setTimeout(() => {
                    setActiveDropdown(null);
                    closeTimeoutRef.current = null;
                  }, 200);
                }}
              >
                {hasChildren ? (
                  <>
                    <button
                      aria-haspopup="true"
                      aria-expanded={activeDropdown === link.href}
                      onClick={() => setActiveDropdown((v) => (v === link.href ? null : link.href))}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setActiveDropdown((v) => (v === link.href ? null : link.href));
                        }
                      }}
                      className="flex items-center gap-2 px-4 py-2 rounded-full font-semibold text-gray-800 glossy-btn relative"
                    >
                      {link.label}
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.12 1l-4.25 4.652a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>

                    {activeDropdown === link.href && (
                      <div className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-100 z-40">
                        <ul className="py-2">
                          {link.children.map((child) => (
                            <li key={child.href}>
                              <a href={child.href} className="block px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-300">
                                {child.label}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </>
                ) : (
                  <a href={link.href} className="block px-4 py-2 rounded-full font-semibold text-gray-800 glossy-btn relative">
                    {link.label}
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      {/* Mobile panel */}
      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-sm border-t border-gray-100 shadow-sm">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <ul className="flex flex-col gap-2">
              {LINKS.map((link) => {
                const hasChildren = Array.isArray(link.children) && link.children.length > 0;
                const isOpen = !!mobileOpenSubmenus[link.href];
                return (
                  <li key={link.href}>
                    <div className="flex items-center justify-between">
                      <a
                        href={link.href}
                        onClick={() => setOpen(false)}
                        className="block px-4 py-3 rounded-lg font-medium text-gray-800 glossy-btn relative flex-1"
                      >
                        {link.label}
                      </a>
                      {hasChildren && (
                        <button
                          onClick={() =>
                            setMobileOpenSubmenus((s) => ({ ...s, [link.href]: !s[link.href] }))
                          }
                          aria-expanded={isOpen}
                          className="p-3"
                        >
                          <span className="sr-only">Toggle submenu</span>
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.12 1l-4.25 4.652a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                          </svg>
                        </button>
                      )}
                    </div>

                    {hasChildren && isOpen && (
                      <ul className="mt-2 ml-4 flex flex-col gap-1">
                        {link.children.map((child) => (
                          <li key={child.href}>
                            <a
                              href={child.href}
                              onClick={() => setOpen(false)}
                              className="block px-4 py-2 rounded-md text-gray-700 hover:bg-green-50 hover:text-green-300"
                            >
                              {child.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;